/** Formatting helpers for Stripe billing data (amounts in cents, unix-second dates). */

/** Format a Stripe amount (smallest currency unit, e.g. cents) as currency. */
export const formatBillingAmount = (
    amount: number | null | undefined,
    currency: string | null | undefined
): string => {
    if (amount == null) return '—';
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: (currency ?? 'usd').toUpperCase(),
        }).format(amount / 100);
    } catch {
        // Fall back to a plain dollar format for unknown currency codes.
        return `$${(amount / 100).toFixed(2)}`;
    }
};

/** Format a unix-second timestamp as a short date (e.g. "Jul 17, 2026"). */
export const formatBillingDate = (unixSeconds: number | null | undefined): string => {
    if (unixSeconds == null) return '—';
    return new Date(unixSeconds * 1000).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};

/** Human-friendly recurring interval suffix, e.g. "/mo", "/yr", "every 3 mo". */
export const formatInterval = (
    interval: string | null | undefined,
    intervalCount?: number | null
): string => {
    if (!interval) return '';
    const short = interval === 'month' ? 'mo' : interval === 'year' ? 'yr' : interval;
    if (intervalCount && intervalCount > 1) return `every ${intervalCount} ${short}`;
    return `/${short}`;
};
